<template>
  <register-form />
</template>

<script>
  import RegisterForm from '@core/components/auth/register-form/register-form';
  export default {
    components: {
      RegisterForm
    }
  };
</script>
